export default {"src":"/_next/static/media/roadwise-logo-dark-en.ad4791a1.svg","height":47,"width":109,"blurWidth":0,"blurHeight":0};